// extracted by mini-css-extract-plugin
export default {"multisignConfirmTxLink":"JpIyfnBqgK1dqI8satNC","centerAlign":"XTL0jT5t2nssRR6FMIBz","sendBtnsWrapper":"olBe6EThkSWmTk9HZdPA","actionBtn":"kiAdZ_XcdbLRJJk9GC3G"};